import actionService from "../../services/action.service";


    export const state ={
        totalPages: 0,

        actions:[],
        action_distribution:[],

        totalActions: 0,
        directActions: 0,
        indirectActions: 0,

        // Stats for the actions list page (respect the active list filters)
        list_stats: { total: 0, direct: 0, indirect: 0, companies: 0 },

        regionData:[],
        actions_by_month:[],
        actions_by_year:[],
        year_categories:[],

        //action intentions
        intention_distribution:[],
        intention_distribution_labels:[],
        intention_distribution_yearly:[],
        intention_distribution_yearly_categories:[],
        intention_distribution_monthly:[],

        response_distribution:[],
        response_distribution_yearly:[],
        response_distribution_yearly_categories:[],
        response_distribution_monthly:[],
        
    }
    export const actions = {
        fetch_actions({commit}, payload){
                // Assuming payload contains the 'page', 'is_verified' and optional 'filters' fields
                const { page, is_verified, filters } = payload;

                return actionService.get_actions(page, is_verified, filters || {}).then(
                    data => {
                        commit('SET_ACTIONS', data.data);
                        commit('SET_ACTION_LIST_STATS', data.stats);
                        return Promise.resolve(data);
                    }, error => {
                        commit('AssetsFailed');
                        return Promise.reject(error);
                    }
                );
        },
        fetch_user_actions({commit}, payload){
            return  actionService.get_user_actions(payload).then(
                data => {            
                         
                    commit ('SET_USER_ACTIONS', data.data);
                    return Promise.resolve(data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },


        async fetch_action_type_distribution({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.action_type_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_DISTRIBUTION', response.data);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetchActionsByRegion({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.actions_by_region(yearParam).then(
                    response => {
                        
                        commit('setActionsRegionData', response.data);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetchActionsByMonth({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.actions_by_month(yearParam).then(
                    response => {
                        
                        commit('setActionsByMonth', response.series);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetchActionsByYear({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.actions_by_year(yearParam).then(
                    response => {
                        
                        commit('setActionsByYear', response.series);
                        commit('setActionsByYearCategories', response.categories);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_action_intention_distribution({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.action_intention_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_INTENTION_DISTRIBUTION', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_action_intention_distribution_yearly({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.yearly_action_intention_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_INTENTION_DISTRIBUTION_YEARLY', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_action_intention_distribution_monthly({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.monthly_action_intention_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_INTENTION_DISTRIBUTION_MONTHLY', response.data);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_action_response_distribution({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.action_response_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_RESPONSE_DISTRIBUTION', response.data);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_response_distribution_yearly({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.yearly_action_response_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_RESPONSE_DISTRIBUTION_YEARLY', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_response_distribution_monthly({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                // API call (replace with your actual API logic)
                await actionService.monthly_action_response_distribution(yearParam).then(
                    response => {
                        
                        commit('SET_ACTION_RESPONSE_DISTRIBUTION_MONTHLY', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },

    }
    export const mutations = {
        SET_ACTIONS(state, payload){
            state.actions = payload.data
            state.totalPages = payload.last_page; // Store total pages

        },
        SET_PAYLOAD(state, payload){
            state.payload = payload
        },

        AssetsFailed(){

        },
        SET_ACTION_DISTRIBUTION(state, data) {
            state.totalActions = data.totalActions;
            state.directActions = data.directActions;
            state.indirectActions = data.indirectActions;
        },
        SET_ACTION_LIST_STATS(state, payload) {
            state.list_stats = payload || { total: 0, direct: 0, indirect: 0, companies: 0 };
        },
        setActionsRegionData(state, data) {
            state.regionData = data;
        },
        setActionsByMonth(state, data) {
            state.actions_by_month = data;
        },
        setActionsByYear(state, data) {
            state.actions_by_year = data;
        },
        setActionsByYearCategories(state, data) {
            
            state.year_categories = data;
            
        },

        SET_ACTION_INTENTION_DISTRIBUTION(state,payload){
            
            state.intention_distribution = payload.data
            
            state.intention_distribution_labels = payload.labels
        },
        SET_ACTION_INTENTION_DISTRIBUTION_YEARLY(state,payload){
            state.intention_distribution_yearly = payload.series
            state.intention_distribution_yearly_categories = payload.labels
        },
        SET_ACTION_INTENTION_DISTRIBUTION_MONTHLY(state,payload){
            state.intention_distribution_monthly = payload
        },
        SET_ACTION_RESPONSE_DISTRIBUTION(state,payload){
            state.response_distribution = payload
        },
        SET_ACTION_RESPONSE_DISTRIBUTION_YEARLY(state,payload){
            state.response_distribution_yearly = payload.series
            state.response_distribution_yearly_categories = payload.labels
        },
        SET_ACTION_RESPONSE_DISTRIBUTION_MONTHLY(state,payload){
            state.response_distribution_monthly = payload.series
        },
    }
    export const getters = {

        get_total_pages: (state) => state.totalPages,

        get_actions(state){
            return state.actions
        },

        get_action_list_stats(state){
            return state.list_stats
        },

        get_total_actions(state){
            return state.totalActions

        },
        get_total_direct_actions(state){
            return state.directActions

        },
        get_total_indirect_actions(state){
            return state.indirectActions

        },
        get_region_data(state){
            return state.regionData

        },
        get_actions_by_month(state){
            return state.actions_by_month

        },
        get_actions_by_year(state){
            return state.actions_by_year
        },
        get_actions_by_year_categories(state){
            
            // let arr = Array.from(state.year_categories) 
            return [...state.year_categories];
        },

        get_actions_intention(state){
            
            return [...state.intention_distribution]
        },
        get_actions_intention_labels(state){
            return state.intention_distribution_labels
        },

        get_actions_intention_monthly(state){
            return state.intention_distribution_monthly
        },
        get_actions_intention_yearly(state){
            return state.intention_distribution_yearly
        },
        get_actions_intention_yearly_categories(state){
            return state.intention_distribution_yearly_categories
        },
        get_actions_response(state){
            return state.response_distribution
        },
        get_actions_response_monthly(state){
            return state.response_distribution_monthly
        },
        get_actions_response_yearly(state){
            return state.response_distribution_yearly
        },
        get_actions_response_yearly_categories(state){
            return state.response_distribution_yearly_categories
        },
       
    }


